export default {
  "wt-tab-list": "_wt-tab-list_b6upoy_1",
  "wt-tab-list__tabs-container": "_wt-tab-list__tabs-container_b6upoy_4",
  "wt-tab-list__left-arrow": "_wt-tab-list__left-arrow_b6upoy_20",
  "wt-tab-list_theme_light": "_wt-tab-list_theme_light_b6upoy_32",
  "wt-tab-list_theme_dark": "_wt-tab-list_theme_dark_b6upoy_37",
  "wt-tab-list__left-arrow_show": "_wt-tab-list__left-arrow_show_b6upoy_42",
  "wt-tab-list__right-arrow": "_wt-tab-list__right-arrow_b6upoy_49",
  "wt-tab-list__right-arrow_show": "_wt-tab-list__right-arrow_show_b6upoy_71",
  "wt-tab-list__separator": "_wt-tab-list__separator_b6upoy_78",
  "wt-tab-list__separator_theme_light": "_wt-tab-list__separator_theme_light_b6upoy_90",
  "wt-tab-list__separator_theme_dark": "_wt-tab-list__separator_theme_dark_b6upoy_93",
  "wt-tab-list__indicator": "_wt-tab-list__indicator_b6upoy_96",
  "wt-tab-list__tab": "_wt-tab-list__tab_b6upoy_4",
  "wt-tab-list__tab_full-text": "_wt-tab-list__tab_full-text_b6upoy_139",
  "wt-tab-list_size_m": "_wt-tab-list_size_m_b6upoy_142",
  "wt-tab-list_size_l": "_wt-tab-list_size_l_b6upoy_150",
  "wt-tab-list__tab_selected": "_wt-tab-list__tab_selected_b6upoy_158",
  "wt-tab-list__ellipsis-text-wrapper": "_wt-tab-list__ellipsis-text-wrapper_b6upoy_183",
  "wt-tab-list__tab-icon": "_wt-tab-list__tab-icon_b6upoy_188",
  "wt-tab-list__content": "_wt-tab-list__content_b6upoy_201",
  "wt-tab-list_mode_short": "_wt-tab-list_mode_short_b6upoy_253",
  "wt-tab-list_mode_default": "_wt-tab-list_mode_default_b6upoy_259",
  "rs-reset-letter-spacing": "_rs-reset-letter-spacing_b6upoy_283"
};